import { render } from "./DashboardEditContractModel.vue?vue&type=template&id=54459b7e&scoped=true"
import script from "./DashboardEditContractModel.vue?vue&type=script&lang=js"
export * from "./DashboardEditContractModel.vue?vue&type=script&lang=js"

import "./DashboardEditContractModel.vue?vue&type=style&index=0&id=54459b7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54459b7e"]])

export default __exports__